// Configuration du planning par défaut
export const daysNames = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
export const monthsNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

// Jours fériés français (dates fixes)
export const frenchHolidays = [
  { d: 1, m: 0, name: "Jour de l'An" },
  { d: 1, m: 4, name: "Fête du Travail" },
  { d: 8, m: 4, name: "Victoire 1945" },
  { d: 14, m: 6, name: "Fête Nationale" },
  { d: 15, m: 7, name: "Assomption" },
  { d: 1, m: 10, name: "Toussaint" },
  { d: 11, m: 10, name: "Armistice 1918" },
  { d: 25, m: 11, name: "Noël" }
];

// Vérifier si une date est un jour férié
export const checkFrenchHoliday = (date) => {
  if (!date) return null;
  const d = date.getDate();
  const m = date.getMonth();
  return frenchHolidays.find(h => h.d === d && h.m === m) || null;
};

// Menus de la semaine
export const dinnerMenus = ["Pâtes 🍝", "Œufs 🍳", "Fromage 🧀", "Poulet 🍗", "Tajine 🥘", "Riz 🍚", "Couscous 🥙"];

// Générer le planning d'une journée
// IMPORTANT: Par défaut, l'emploi du temps est VIERGE
// Seules les tâches personnalisées (customTasks) sont affichées
export const generateDailySchedule = (dayIndex, options = {}) => {
  const { customTasks = [] } = options;

  // Retourner uniquement les tâches personnalisées créées par l'utilisateur
  // L'emploi du temps est vierge par défaut
  return [...customTasks].sort((a, b) => a.time.localeCompare(b.time));
};

// Calculer les dates d'une semaine
export const getWeekDates = (weekOffset = 0) => {
  const dates = [];
  const today = new Date();
  const baseDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const day = baseDate.getDay();
  const diff = baseDate.getDate() - day + (day === 0 ? -6 : 1) + (weekOffset * 7);
  const monday = new Date(baseDate);
  monday.setDate(diff);
  
  for (let i = 0; i < 7; i++) {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    dates.push(d);
  }
  return dates;
};

// Styles par catégorie - couleurs contrastées et lisibles
export const getCategoryStyles = (category, safetyMode = false) => {
  if (safetyMode && category !== 'vital') return 'hidden';
  switch (category) {
    case 'vital': return 'task-vital';      // Rouge - Urgence/Médicaments
    case 'chore': return 'task-chore';      // Ambre/Orange - Corvées/Travail
    case 'pleasure': return 'task-pleasure'; // Vert - Plaisir/Détente
    case 'reward': return 'task-reward';    // Violet - Récompense
    default: return 'task-default';
  }
};
